export default __webpack_public_path__ + "5e9b8cb.png";